export class Note {
  public id: string;
  public description: string;
  public createdBy: string;
  public createdOn: Date;
  public entityId: string;
  public entityType?: NoteEntityType;
  public actionType?: NoteActionType;
  public actionTypeText: string;
  public subtitle: string;
  public canDelete: boolean;

  constructor(note: Partial<Note> = undefined) {
    if (note) this.setProperties(note);
  }

  private setProperties(note: Partial<Note>) {
    this.id = note.id;
    this.description = note.description;
    this.createdBy = note.createdBy;
    this.createdOn = note.createdOn;
    this.entityId = note.entityId;
    this.entityType = note.entityType;
    this.actionType = note.actionType;
    this.subtitle = note.subtitle;
    this.canDelete = note.canDelete;
  }
}

export enum NoteEntityType {
  Scenario = 'Scenario',
  Requirement = 'Requirement',
  Credential = 'Credential',
  InvoiceNote = 'InvoiceNote',
  CredentialApplication = 'CredentialApplication',
  Specialty = 'Specialty'
}

export enum NoteActionType {
  CompleteScenario = 'CompleteScenario',
  ArchiveScenario = 'ArchiveScenario',
  DeleteScenario = 'DeleteScenario',
  CompleteRequirement = 'CompleteRequirement',
  UpdateCredentialDate = 'UpdateCredentialDate',
  InvoiceNote = 'InvoiceNote',
  UpdateCredentialStatus = 'UpdateCredentialStatus',
  ArchiveCredentialApplication = 'ArchiveCredentialApplication',
  UpdateCredentialApplicationStatus = 'UpdateCredentialApplicationStatus',
  DeleteCredentialApplication = 'DeleteCredentialApplication',
  ManuallyCompleteCredentialApplication = 'ManuallyCompleteCredentialApplication',
  AddedSpecialty = 'AddedSpecialty',
  AssignedSpecialty = 'AssignedSpecialty'
}
